// helper-attachments.js
export function getDefaultAttachments({ payrollType, jobType, payItem }) {
  if (
    payrollType === "Individual Payroll" &&
    jobType !== "Job Order" &&
    payItem === "Initial Salary"
  ) {
    return [
      "Appointment",
      "Position Description Form (PDF)",
      "Personal Data Sheet (PDS)",
      "Personnel Order (PO)",
      "Assumption of duty",
      "Oath of Office",
      "Statement of Assets & Liabilities (SALN)",
      "Daily Time Record (DTR)",
      "Computation",
    ];
  }
  if (
    payrollType === "Individual Payroll" &&
    jobType !== "Job Order" &&
    payItem === "Last Salary"
  ) {
    return [
      "Photocopy of Statement of Employee's Earnings",
      "Office Clearance",
      "Declaration of pendency/non-pendency of case",
      "Notice of Salary Adjustment (NOSA)",
      "Statement of Assets & Liabilities (SALN)",
      "Appointment",
      "Daily Time Record (DTR)",
      "Service Record",
      "Computation",
    ];
  }
  if (
    payrollType === "Individual Payroll" &&
    jobType !== "Job Order" &&
    payItem === "Initial Salary(AP)"
  ) {
    return [
      "Appointment",
      "Position Description Form (PDF)",
      "Personal Data Sheet (PDS)",
      "Personnel Order (PO)",
      "Assumption of duty",
      "Oath of Office",
      "Statement of Assets & Liabilities (SALN)",
      "Daily Time Record (DTR)",
      "Computation",
      "Monthly Accomplishment Report",
      "Alphalist",
      "TO/LD/OB/SOA, if any",
    ];
  }
  if (
    payrollType === "Individual Payroll" &&
    jobType !== "Job Order" &&
    payItem === "Last Salary(AP)"
  ) {
    return [
      "Accomplishment Report",
      "Alphalist",
      "Daily Time Record (DTR)",
      "Office Clearance",
      "Declaration of Pendency / Non- Pendency Case",
      "Service Record",
      "TO | LD | OB | SOA, if any",
    ];
  }
  if (
    payrollType === "Individual Payroll" &&
    jobType === "Job Order" &&
    payItem === "Initial Salary"
  ) {
    return [
      "Engagement of Service",
      "Personnel Order",
      "Assumption of duty",
      "Statement of Assets & Liabilities",
      "Personal Data Sheet (PDS)",
      "Accomplishment Report",
      "Daily Time Record (DTR)",
      "Credentials, if any",
      "Copy of Landbank Account Number",
      "Clearance, if any",
      "Computation",
    ];
  }
  if (
    payrollType === "Individual Payroll" &&
    jobType === "Job Order" &&
    payItem === "Last Salary"
  ) {
    return [
      "Computation",
      "Clearance",
      "Accomplishment Report",
      "Daily Time Record (DTR)",
      "Letter of  Acceptance/Termination End of Contract",
      "Statement of Employee's Earnings",
    ];
  }
  if (
    payrollType === "Individual Payroll" &&
    payItem === "Salary Differential (Basic)"
  ) {
    return [
      "Appointment",
      "PDF",
      "PDS",
      "Personnel Order",
      "Assumption of Duty",
      "Oath of Office",
      "Statement of Assests & Liabilities",
      "Statement of Employee's Earnings",
      "Computation",
    ];
  }

  console.log("");
  if (payItem === "Initial RATA") {
    return ["Assumption"];
  }
  if (payrollType === "Special Payroll" && payItem === "20% Monthly Premium") {
    return ["Payroll 1-Sheet/s", "FinDES-PACS 1-Sheet/s"];
  }

  const normalize = (str) => str?.trim().toLowerCase();

  const isCollectiveNegotiationIncentive = (payItem) => {
    return normalize(payItem) === "collective negotiation agreement incentive";
  };
  const isClothingIncentive = (payItem) => {
    return normalize(payItem) === "clothing allowance";
  };
  const isMidYear = (payItem) => {
    return normalize(payItem) === "mid year-bonus";
  };
  const isSubsistence = (payItem) => {
    return (
      normalize(payItem) === "subsistence , laundry, allowance, hazard pay"
    );
  };
  const isPerformanceBased = (payItem) => {
    return normalize(payItem) === "performance based bonus";
  };
  if (isCollectiveNegotiationIncentive(payItem)) {
    return ["Payroll 1-Sheet/s", "Findes 1-Sheet/s"];
  }
  if (isClothingIncentive(payItem)) {
    return ["Payroll 24-Sheet/s", "FinDES-PACS 1-Sheet/s"];
  }
  if (isMidYear(payItem)) {
    return ["Payroll 21-Sheet/s", "FinDES-PACS 1-Sheet/s"];
  }
  if (isSubsistence(payItem)) {
    return [
      "Payroll 1-Sheet/s",
      "FinDES-PACS 1-Sheet/s",
      "Memo for Magna Carta",
      "DTRs for the period(with attachments)",
      "Alphalist and CMAR",
    ];
  }
  if (isPerformanceBased(payItem)) {
    return ["Payroll 1-Sheet/s", "FinDES-PACS 1-Sheet/s"];
  }
  const defaultAttachmentsMap = {
    "Basic Pay": ["Payroll-1 Sheet/s", "FinDES-PACS-1 Sheet/s"],
    "Augmentation Pay": ["Payroll-1 Sheet/s", "FinDES-PACS-1 Sheet/s"],
  };
  return defaultAttachmentsMap[payrollType] || [];
}
